import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { Theme, ThemeContext, ThemeContextType, Themes } from "./ThemeContext";

interface ThemeProviderProps {
	children: ReactNode;
	defaultTheme?: Theme;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({
	children,
	defaultTheme = 'light'
}) => {
	const [isDarkMode, setIsDarkMode] = useState(false);
	const [theme, setTheme] = useState<Theme>(defaultTheme);

	useEffect(() => {
		// Remove all theme classes
		document.documentElement.classList.remove(...Object.keys(Themes));

		// Add the selected theme
		document.documentElement.classList.add(theme);

		// Save to localStorage
		localStorage.setItem('theme', theme);

		setIsDarkMode(theme === 'dark');

	}, [theme]);

	// Load theme from localStorage on mount
	useEffect(() => {
		const storedTheme = localStorage.getItem('theme');
		if (storedTheme && (storedTheme in Themes)) {
			setTheme(storedTheme as Theme);
		}
	}, []);

	const nextTheme = () => {
		const themeKeys = Object.keys(Themes) as Theme[];
		const currentIndex = themeKeys.indexOf(theme);
		const nextIndex = (currentIndex + 1) % themeKeys.length;
		setTheme(themeKeys[nextIndex]);
	};

	const value: ThemeContextType = {
		theme,
		setTheme,
		nextTheme,
		isDarkMode,
	};

	return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};
